exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-subscribed {\n  background: linear-gradient(90deg, #266cd2 0%, #3A91F9 100%);\n}\n.bg-premium {\n  background: linear-gradient(90deg, #FFC107 0%, #FFEB3B 100%);\n}\n", ""]);

// exports
